import { connect } from 'react-redux';
import { getTranslation } from "../../../reducers/common/localization";
import AdminSecurityComponent from "./AdminSecurityComponent";
import {
    fetchGetOrgsWithoutCertificates,
    loadingOrgsWithoutCertificates,
    getOrgsWithoutCertificatesFormattedData,
    getFirstCertificatesData,
    removeOrgWithoutCertificatesFromPage
} from '../../../reducers/organization/orgsWithoutCertificates';
import { showModal, MODAL_ADD_ORG_FIRST_CERTIFICATE } from '../../../reducers/common/activeModal';

const mapStateToProps = state => {
    return {
        translation: getTranslation(state),
        loading: loadingOrgsWithoutCertificates(state),
        data: getOrgsWithoutCertificatesFormattedData(state),
        certificatesData: getFirstCertificatesData(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onMount: () => {
            dispatch(fetchGetOrgsWithoutCertificates());
        },
        onAddCertificate: () => dispatch(showModal({ modalKey: MODAL_ADD_ORG_FIRST_CERTIFICATE })),
        onConfirmSent: (orgId) => {
            dispatch(removeOrgWithoutCertificatesFromPage(orgId));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminSecurityComponent);


// WEBPACK FOOTER //
// ./src/components/securityManagement/adminSecurityComponent/AdminSecurityComponent.container.js